import React, { useState } from "react";
import Chart from "../Chart";
import FormApply from "../FormEntry";
import { getListPartnerName } from "components/ListPartner";
import {
  getTitleDecoration,
  formatSimpleDate,
  getDayOfDate,
} from "utils/common";

const CardEntry = ({ entry, setEntrySetting, openModal }) => {
  const [show, setShow] = useState(false);

  const OpenModalPartner = () => {
      setEntrySetting(entry);
      openModal("modal-partner");
  };

  return (
    <div className={`content-box mb-2 ${show ? "active" : ""}`}>
      <div className="label">
        <div className="px-2 px-md-3 py-2 bg-white">
          <div className="row gx-0 align-items-center">
            <div className="w-entries-1 fw-600">
              <div
                className="d-block d-md-inline-block my-1 my-md-0"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    entry?.title_decoration?.title_decoration_content
                  ),
                }}
              ></div>
              <span className="align-middle">{entry.title_login}</span>
            </div>
            <div className="w-entries-2 align-self-start text-start text-md-end">
            {(!entry.lock_partnership && entry.partner_flg === 1) && (
              <div
                onClick={OpenModalPartner}
                className={`btn-clap-app green me-2`}
              >
                同行者の確認・変更
              </div>
            )}
              <a
                href={"entries/detail/" + entry?.promotion_id }
                className="btn-clap-app red-light my-1 my-md-0"
              >
                案件内容
              </a>
            </div>
          </div>
          <div className="mt-2 fs-12 fw-600 pb-4 pb-md-1 row">
              <div className="fs-14 col-sm">
                    {entry?.effective_date && (
                      <span>
                        収録日 ：
                        {entry?.effective_date}
                      </span>
                    )}
              </div>
              <div className="fs-14 col-sm text-lg-end">
                  {entry?.apply_date && (
                    <span className="me-2">
                      応募日 ：
                      {formatSimpleDate(entry?.apply_date)}(
                      {getDayOfDate(entry?.apply_date)})
                    </span>
                  )}
              </div>
          </div>
          <div className="mt-2">
            {entry.promotion_sets.map((p) => {
                return (
                  <div key={p.id} className="my-2 fw-600 fs-13">
                    { entry?.split_flg == 1 &&
                    <div className="bg-violet px-2 py-1 fs-sm-12">{p.name}</div>}
                    {entry.partner_flg === 1 && 
                    <div className="bg-pink px-2 py-1 py-1 fs-sm-9">
                      同行者：{getListPartnerName(p.id, entry.partnerships)}
                    </div>}
                  </div>
                );
            })}
          </div>

          <div className="highlight position-relative">
            現在のステップ : {entry?.step_name}
          </div>
        </div>

        <div onClick={() => setShow(!show)} className="label-footer py-2">
          <span className="icon-rotate me-3">
            <svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.80006 4.79778L15.0302 0.158203L16.1104 1.84145L7.75685 7.20187L0.000324206 1.8215L1.14024 0.178151L7.80006 4.79778Z"
                fill="white"
              />
            </svg>
          </span>
          <div>ステップ詳細</div>
        </div>
      </div>
      <div className="content-body">
        <div className="d-flex flex-wrap p-0 p-lg-3">
          <div className="content-chart position-relative text-center">
            <Chart item={entry} />
          </div>

          <div className="content-main p-3 py-0 fs-14 fw-400 text-grey">
            <div className="my-2">
              <div
                className="html-design-table my-2"
                dangerouslySetInnerHTML={{
                  __html: entry.step_description,
                }}
              ></div>
              <FormApply
                item={entry}
                openFn={openModal}
                setEntrySetting={setEntrySetting}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardEntry;
